import React from 'react';
import { components } from 'react-select';
import { ArrowV } from '~static/svg-components';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <ArrowV style={{ fontSize: 'inherit', transform: 'rotate(90deg)' }} />
  </components.DropdownIndicator>
);

export default DropdownIndicator;
